/**
 * @generated SignedSource<<6729856e33d535869000625111b72429>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSharedHeroCarousel_viewer$data = {
  readonly muxMonitoringFF: boolean | null;
  readonly vimeoItemsVideoHLSPlayerFF: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedImageGalleryModal_viewer">;
  readonly " $fragmentType": "PdpRespSharedHeroCarousel_viewer";
};
export type PdpRespSharedHeroCarousel_viewer$key = {
  readonly " $data"?: PdpRespSharedHeroCarousel_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSharedHeroCarousel_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSharedHeroCarousel_viewer",
  "selections": [
    {
      "alias": "vimeoItemsVideoHLSPlayerFF",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "vimeoItemsVideoHLSPlayer"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"vimeoItemsVideoHLSPlayer\")"
    },
    {
      "alias": "muxMonitoringFF",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "muxMonitoring"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"muxMonitoring\")"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedImageGalleryModal_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "faa4a4c689dec8081d11a9274c2a0ef6";

export default node;
